import { EppService } from '../epp/epp.service';
import { RouteFcstService } from './route-fcst.service';

import { ColorMappingCondPipe } from './pipes/color-mapping-cond.pipe';
import { ColorMappingTempPipe } from './pipes/color-mapping-temp.pipe';
import { ColorMappingWarnPipe } from './pipes/color-mapping-warn.pipe';

import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, signal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

export const MODULES = [CommonModule, MatTooltipModule, TranslateModule];
export const PIPES = [
  ColorMappingCondPipe,
  ColorMappingTempPipe,
  ColorMappingWarnPipe,
];
@Component({
  selector: 'app-route-fcst-legend',
  templateUrl: './route-fcst-legend.component.html',
  styleUrls: [
    './route-fcst-legend.component.scss',
    './route-fcst.component.scss',
  ],
  imports: [...MODULES, ...PIPES],
})
export class RouteFcstLegendComponent implements OnInit {
  public routeFcstService = inject(RouteFcstService);
  public eppService = inject(EppService);

  legendToShow = input<string>();

  radarLegendNames = ['RAIN', 'SNOWrainGRAUPEL', 'HailSnow', 'ICERAIN'];

  translationWinter = [
    'OTHER',
    'WETNESS',
    'RIME',
    'FREEZING_WETNESS',
    'FREEZING_RAIN',
    'SNOW',
  ];
  conditions = [
    [0, 19, 19],
    [2, 3, 4],
    [5, 9, 14],
    [6, 10, 15],
    [7, 11, 16],
    [8, 13, 18],
    [1, 12, 17],
  ];

  roadTemperatures = ['> 3', '<= 3', '<= 1', '<= 0', '<= -6', '<= -13'];
  roadWarnLevels = [0, 1, 2, 3];
  igpLevels = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ];
  igcLevels = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
  ];
  igpLegend = signal([]);
  igcLegend = signal([]);

  ngOnInit(): void {
    this.initGrittingIndexLegends();
  }

  initGrittingIndexLegends() {
    this.eppService.getDefaultParametersetDetails(['action-index']).then(() => {
      this.eppService.getColorMappings().then(() => {
        this.igpLegend.set([
          ...this.eppService.getLegend('i_gp', 'action-index'),
        ]);
        this.igcLegend.set([
          ...this.eppService.getLegend('i_gc', 'action-index'),
        ]);
      });
    });
  }
}
